//const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://cmpl.vercel.app/api/v1';
// const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4300/api/v1';
const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';

const API_ENDPOINTS = {
  AUTH: {
    ADMIN_LOGIN: `${BASE_URL}/admin/login`, // POST: Admin login
  },
  PACKAGES: {
    GET_ALL: `${BASE_URL}/package`, // GET: Fetch all sales
    ADD: `${BASE_URL}/package`, // POST: Add a new sale
    UPDATE: (id) => `${BASE_URL}/package/find/${id}`, // PATCH: Update sale by ID
    DELETE: (id) => `${BASE_URL}/package/find/${id}`, // DELETE: Delete sale by ID
    GET_ONE: (id) => `${BASE_URL}/package/find/${id}` // GET: Fetch one sale by ID
 }, 
  Category: {
    GET_ALL: `${BASE_URL}/packagecategory`,
    ADD: `${BASE_URL}/packagecategory`,
    UPDATE: (id) => `${BASE_URL}/packagecategory/find/${id}`,
    DELETE: (id) => `${BASE_URL}/packagecategory/find/${id}`,
    GET_BY_ID: (id) => `${BASE_URL}/packagecategory/find/${id}`,
  },
  OPINIONS: {
    GET_ALL: `${BASE_URL}/opinion`, // GET: Fetch all sales
    ADD: `${BASE_URL}/opinion`, // POST: Add a new sale
    UPDATE: (id) => `${BASE_URL}/opinion/find/${id}`, // PATCH: Update sale by ID
    DELETE: (id) => `${BASE_URL}/opinion/find/${id}`, // DELETE: Delete sale by ID
    GET_ONE: (id) => `${BASE_URL}/opinion/find/${id}` // GET: Fetch one sale by ID
  },
  OFFERS:{
    GET_ALL: `${BASE_URL}/sale`, // GET: Fetch all sales
    ADD: `${BASE_URL}/sale`, // POST: Add a new sale
    UPDATE: (id) => `${BASE_URL}/sale/find/${id}`, // PATCH: Update sale by ID
    DELETE: (id) => `${BASE_URL}/sale/find/${id}`, // DELETE: Delete sale by ID
    GET_ONE: (id) => `${BASE_URL}/sale/find/${id}` // GET: Fetch one sale by ID
  },
  INFOS: {
    GET_ALL: `${BASE_URL}/medicalinfo`, // GET: Fetch all sales
    ADD: `${BASE_URL}/medicalinfo`, // POST: Add a new sale
    UPDATE: (id) => `${BASE_URL}/medicalinfo/find/${id}`, // PATCH: Update sale by ID
    DELETE: (id) => `${BASE_URL}/medicalinfo/find/${id}`, // DELETE: Delete sale by ID
    GET_ONE: (id) => `${BASE_URL}/medicalinfo/find/${id}` // GET: Fetch one sale by ID
  },
  MAILS:{
    REPORT: `${BASE_URL}/mail/report`,          // POST: Send report email
    WITHDRAWAL: `${BASE_URL}/mail/withdrawal`,  // POST: Send withdrawal email with file uploads
    BOOKING: `${BASE_URL}/mail/booking`,        // POST: Send booking email
    CONTACT: `${BASE_URL}/mail/sentContact`     // POST: Send contact email
  }
  // Add more endpoints as needed
};

export default API_ENDPOINTS;
// http://localhost:4200


